import React from "react";
import { ClipboardList, Truck, MapPin, ShieldCheck } from "lucide-react";

const STEPS = [
  {
    icon: ClipboardList,
    n: "01",
    title: "Request a Direct Quote",
    desc: "Submit the route, vehicle type, and preferred date through our quote form or call dispatch at 403-354-3434. We respond with a firm, all-in price within one business day — no broker markup, no fuel-surcharge surprises.",
  },
  {
    icon: ShieldCheck,
    n: "02",
    title: "We Schedule & Confirm",
    desc: "Once you accept, we lock the date and assign one of our own drivers (never a load-board stranger). You receive insurance details, pickup window, and a direct phone line to your driver.",
  },
  {
    icon: Truck,
    n: "03",
    title: "Pickup & Inspection",
    desc: "Your driver arrives at the scheduled door. RVs are strapped, motorcycles soft-tied in enclosed trailers, ATVs and snowmobiles secured for road or winter conditions. Photo condition report completed on the spot.",
  },
  {
    icon: MapPin,
    n: "04",
    title: "Delivery — Same Driver",
    desc: "The same driver hauls coast-to-coast (or wherever your destination sits) and delivers to your door. Final inspection, photo report, signature — done. One company, one truck, one accountable team from start to finish.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      className="bg-[#EAEAE5] border-b-2 border-[#122A1E]"
      data-testid="process-section"
      aria-labelledby="process-heading"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid lg:grid-cols-12 gap-10 mb-12">
          <div className="lg:col-span-5">
            <div className="font-mono-accent text-[11px] uppercase text-[#4A5550] mb-3">
              ◆ 008 · How It Works
            </div>
            <h2
              id="process-heading"
              className="font-display font-black uppercase tracking-tighter leading-none text-[#0A0E0C] text-4xl md:text-5xl"
            >
              Our RV &amp; Motorcycle Transport Process.
            </h2>
          </div>
          <div className="lg:col-span-7 text-[#4A5550] text-base leading-relaxed">
            <p>
              Hauling an <strong>RV across Canada</strong>, shipping a{" "}
              <strong>motorcycle from BC to Ontario</strong>, or moving a{" "}
              <strong>boat from Quebec to the prairies</strong> sounds
              complicated — but our four-step direct-carrier process keeps it
              simple, transparent, and predictable. No broker chains, no surprise
              charges, no driver hand-offs. Just one company, one truck, one
              promise: your unit arrives on time and in the condition it left.
            </p>
          </div>
        </div>

        <ol className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {STEPS.map((s, i) => (
            <li
              key={i}
              className="border-2 border-[#122A1E] bg-[#F4F4F1] p-7 hover-lift"
              data-testid={`process-step-${i + 1}`}
            >
              <div className="flex items-start justify-between gap-4 mb-4">
                <div className="w-12 h-12 bg-[#122A1E] text-[#F4F4F1] flex items-center justify-center">
                  <s.icon size={20} strokeWidth={2.2} />
                </div>
                <div className="font-display font-black text-[#FF5A00] text-4xl leading-none">
                  {s.n}
                </div>
              </div>
              <h3 className="font-display font-black uppercase tracking-tight text-xl md:text-2xl text-[#0A0E0C] leading-tight">
                {s.title}
              </h3>
              <p className="mt-3 text-[#4A5550] text-base leading-relaxed">
                {s.desc}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
